import { Button, Flex, Image, Table, Tag } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useState } from 'react';
import { bgRedditAPI, bgV2DataAPI } from '../api/bd-controller';
import { openNotification } from '../meta/globalToaster';

import './bg-page.css';
import ModalComponent from './ModalComponent';

const RedditDataExtractor = () => {
  const [loading, setLoading] = useState(false);

  const [proDataSource, setProDataSource] = useState<any>([]);
  const [bsDataSource, setBSDataSource] = useState<any>([]);

  const [brand, setBrand] = useState('Bonobos');
  const [category, setCategory] = useState('Clothing & Fashion');
  const [query, setQuery] = useState('Reviews');

  const [isPro, setIsPro] = useState(false);

  const checkBDResult = () => {
    if (brand != '' && query != '' && category != '') {
      setProDataSource([]);
      setBSDataSource([]);
      setLoading(true);
      setIsPro(false);
      bgRedditAPI({ brand: brand, query: query, category: category }).then((data) => {
        try {
          if (
            data?.praw_data &&
            data?.praw_data?.length > 0 &&
            data?.selenium_data &&
            data?.selenium_data?.length > 0
          ) {
            successSubmission(data?.praw_data, data?.selenium_data);
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const successSubmission = (praw_data: any, bs4_data: any) => {
    let dataSourceTemp: any = [];

    praw_data?.map((item: any) => {
      dataSourceTemp = [
        ...dataSourceTemp,
        {
          search_query: item?.search_query,
          subreddit: item?.subreddit,
          score: item?.score,
          submission_title: item?.submission_title,
          subreddit_description: item?.subreddit_description,
          submission_url: item?.submission_url,
          submission_date: item?.submission_date,
          submission_content: item?.submission_content,
          comments: item?.comments,
        },
      ];
    });
    console.log('1');
    setProDataSource(dataSourceTemp);

    dataSourceTemp = [];
    bs4_data?.map((item: any) => {
      dataSourceTemp = [
        ...dataSourceTemp,
        {
          search_query: item?.search_query,
          subreddit: item?.subreddit,
          score: item?.score,
          submission_title: item?.submission_title,
          subreddit_description: item?.subreddit_description,
          submission_url: item?.submission_url,
          submission_date: item?.submission_date,
          submission_content: item?.submission_content,
          comments: item?.comments,
        },
      ];
    });

    setBSDataSource(dataSourceTemp);

    setLoading(false);
  };

  const failSubmission = (message: any) => {
    setLoading(false);
    openNotification({ message });
  };

  const columns = [
    {
      title: 'search_query',
      dataIndex: 'search_query',
      key: 'search_query',
    },
    {
      title: 'subreddit',
      dataIndex: 'subreddit',
      key: 'subreddit',
    },
    // {
    //   title: 'score',
    //   dataIndex: 'score',
    //   key: 'score',
    // },
    {
      title: 'submission_title',
      dataIndex: 'submission_title',
      key: 'submission_title',
    },
    {
      title: 'subreddit_description',
      dataIndex: 'subreddit_description',
      key: 'subreddit_description',
    },
    {
      title: 'submission_url',
      dataIndex: 'submission_url',
      key: 'submission_url',
      render: (text: any) => (
        <a href={text} target="_blank">
          {text}
        </a>
      ),
    },
    {
      title: 'submission_date',
      dataIndex: 'submission_date',
      key: 'submission_date',
    },
    {
      title: 'submission_content',
      dataIndex: 'submission_content',
      key: 'submission_content',
      render: (text: any) => <ModalComponent text={text} isComment={false} />,
    },
    {
      title: 'comments',
      dataIndex: 'comments',
      key: 'comments',
      render: (text: any) => <ModalComponent text={text} isComment={true} />,
    },
  ];

  return (
    <div>
      <div className="container p-3">
        <div className="row">
          <div className="col-sm-12">
            <h4>Brand Discovery</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            {/* <p className="a-input-label">Company URL</p> */}
            <TextArea
              value={brand}
              onChange={(e) => {
                setBrand(e?.target?.value);
              }}
              placeholder="Brand"
              rows={1}
            />
          </div>
          <div className="col-sm-3">
            {/* <p className="a-input-label">Company URL</p> */}
            <TextArea
              value={category}
              onChange={(e) => {
                setCategory(e?.target?.value);
              }}
              placeholder="Category"
              rows={1}
            />
          </div>
          <div className="col-sm-3">
            {/* <p className="a-input-label">Company URL</p> */}
            <TextArea
              value={query}
              onChange={(e) => {
                setQuery(e?.target?.value);
              }}
              placeholder="Query"
              rows={1}
            />
          </div>
          <div className="col-sm-3">
            <Button
              type="primary"
              size="large"
              style={{ width: '100%' }}
              onClick={() => {
                checkBDResult();
              }}
              loading={loading}
            >
              Check Result
            </Button>
          </div>
        </div>

        {proDataSource?.length > 0 && bsDataSource?.length && (
          <>
            <div className="row">
              <div className="col-sm-12">
                <hr />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-sm-2">
                <Button
                  type={isPro ? 'primary' : 'default'}
                  size="large"
                  style={{ width: '100%' }}
                  onClick={() => {
                    setIsPro(true);
                  }}
                  loading={loading}
                >
                  Pro API
                </Button>
              </div>
              <div className="col-sm-2">
                <Button
                  type={isPro ? 'default' : 'primary'}
                  size="large"
                  style={{ width: '100%' }}
                  onClick={() => {
                    setIsPro(false);
                  }}
                  loading={loading}
                >
                  Beautiful Soup
                </Button>
              </div>
            </div>

            {isPro ? (
              <div className="row container-fluid">
                <div className="col-sm-12">
                  <Table dataSource={proDataSource} columns={columns} style={{ width: '100%' }} />
                </div>
              </div>
            ) : (
              <div className="row container-fluid">
                <div className="col-sm-12">
                  <Table dataSource={bsDataSource} columns={columns} style={{ width: '100%' }} />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RedditDataExtractor;
